import { Center, OrbitControls } from '@react-three/drei'
// import { Perf } from 'r3f-perf'
import { Leva } from 'leva'
import Room from './room/Room'
import Furniture from './furniture/Furniture'

export default function Experience()
{
    return <>
        {/* <Perf position="top-left" /> */}
        <OrbitControls 
            makeDefault
            minAzimuthAngle={0} // limit rotation towards +Z
            maxAzimuthAngle={Math.PI / 2} // limit rotation towards +X
        />
        <color args={ [ '#241a1a' ] } attach="background" />
        
        <Room />
        <Furniture />
    </>
}